import React from 'react'
import { useState } from 'react'
import './FAQS.css'


const FAQS = ({ faqs, faqTitle }) => {
   

    return (
        <div className="app__faq-container">
            <h3 className="h2__roboto faq__title"> {faqTitle} </h3>
            {faqs.map((faq) => (
                <FAQSItem key={faq.id} question={faq.question} answer={faq.answer} url={faq.url} />
            ))}
        </div>

    )
}

function FAQSItem({ question, answer, url }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleFaq = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={"faq " + (isOpen ? 'open' : '')}
        
        onClick={() => toggleFaq(setIsOpen)} >
            <div className="app__faq-question">
                <h3 className="h3__roboto">{question}</h3>
            </div>
            <div className="app__faq-answer">
                {isOpen && (
                <div className="app__faq-answer">                
                    <h4 className="h4__opensans-faq">{answer}  </h4>
                <h4 className="h4__opensans-faq_url"> {url}  </h4>
                </div>
                )}
            </div>
        </div>
    );
}

export default FAQS